/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { assignBudgetsStyles } from "@monsma/Overrides/Widgets/Budget/AssignBudgets";
import { css } from "styled-components";

assignBudgetsStyles.titleGridItem = {
    width: [10, 10, 8, 8, 8],
    css: css`
        padding: 15px;
    `,
};

assignBudgetsStyles.buttonsGridItem = {
    width: [2, 2, 4, 4, 4],
    css: css`
        justify-content: flex-end;
        align-items: center;
    `,
};

assignBudgetsStyles.cancelButton = {
    variant: "secondary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        width: 50%;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

assignBudgetsStyles.budgetYearGridItem = {
    width: 12,
    css: css`
        padding: 0 15px 0 15px;
    `,
};

assignBudgetsStyles.assignBudgetInstructionsGridItem = {
    width: 12,
    css: css`
        padding: 15px 15px 0 15px;
    `,
};

assignBudgetsStyles.xAssignBudgetsStyles = {
    budgetAmountWrapper: {
        css: css`
            display: inline-flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: row;
        `,
    },

    bottomButtonsGridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            justify-content: flex-end;
        `,
    },
};
